import { render, staticRenderFns } from "./LicenseSkills.vue?vue&type=template&id=280c7244&"
import script from "./LicenseSkills.vue?vue&type=script&lang=js&"
export * from "./LicenseSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports